import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import useMeta from '@/composables/useMeta';
import useContext from '@/composables/useContext';


// This is needed for async import to work for some reason
import { defineComponent } from "vue";
const __default__ = defineComponent({});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ContentPage',
  setup(__props) {

const { page } = useContext();

useMeta();

return (_ctx: any,_cache: any) => {
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!

  return (_openBlock(), _createBlock(_component_blocks_repeater, {
    blocks: _unref(page).blocks
  }, null, 8, ["blocks"]))
}
}

})